import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FileManagerService} from '../../../file-manager/file-manager.service';
import {Globals} from '../../../../globals';

@Component({
  selector: 'app-forms-full-size-image-dialog',
  templateUrl: './forms-full-size-image-dialog.component.html',
  styleUrls: ['./forms-full-size-image-dialog.component.scss']
})
export class FormsFullSizeImageDialogComponent implements OnInit {
  imagePath: string;

  constructor(@Inject(MAT_DIALOG_DATA) public documentFileName: string, public documentService: FileManagerService, public globals: Globals) {

  }

  ngOnInit(): void {
    this.imagePath = this.documentService.getPatientDocumentUrl(this.globals.ThePatient.PatientId, this.documentFileName);
  }

}
